import React from "react";
import "jspdf-autotable";
import { useParams } from "react-router-dom";
import { GetModuleResourceAudit, getModuleResourceAuditFilters } from "../../../services/CourseService";
import { RenderAuditTrailResourceType } from "../../../utils/CommonGroupingItem";
import AuditTrailsTable from "../../common/AuditTrailsTable";

const AuditTrail = () => {
  const {id} = useParams()
  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"]

  return (
    <AuditTrailsTable
      apiFunction={GetModuleResourceAudit}
      apiParams={{}}
      columnsToShow={columnsToShow}
      filterArrApi={getModuleResourceAuditFilters}
      exportFileName={"PMC_Feature_&_benefits_AuditTrails"}
      isResourceNameShown={true}
      isShowingResourceTypeFilter
      renderResourceTypeFunction={RenderAuditTrailResourceType}
    />
  )
}
export default AuditTrail;